import { JSONContent } from '@tiptap/core'
import { BaseHubBlock, BaseHubInlineBlock } from './rich-text-extensions'

export const getIdFromBaseHubNode = (node: JSONContent): string | null => {
  // if is basehub block or inline block
  if (node.type === BaseHubBlock.name && node.attrs) {
    return node.attrs.id
  }
  const mark = node.marks?.find((mark) => mark.type === BaseHubInlineBlock.name)
  if (mark && mark.attrs) {
    return mark.attrs.id
  }
  return null
}
